/**
 * @generated SignedSource<<95d4abafcfb290f631a217330c0a3956>>
 * @relayHash 59527960279493483dc426741a94e942
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 27842af21d3c4a1c89e9cf81f5d797dbb89b3da4ac6cc54f90271e8a38b37e39

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFormattingArea = "CELL" | "ROW" | "%future added value";
export type JiraFormattingMultipleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "HAS_ANY_OF" | "%future added value";
export type JiraFormattingNoValueOperator = "IS_EMPTY" | "IS_NOT_EMPTY" | "%future added value";
export type JiraFormattingSingleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "DOES_NOT_EQUAL" | "EQUALS" | "GREATER_THAN" | "GREATER_THAN_OR_EQUALS" | "IS" | "IS_AFTER" | "IS_BEFORE" | "IS_NOT" | "IS_ON_OR_AFTER" | "IS_ON_OR_BEFORE" | "LESS_THAN" | "LESS_THAN_OR_EQUALS" | "%future added value";
export type formatRulesQuery$variables = {
  cloudId: string;
  first: number;
  projectKey: string;
};
export type formatRulesQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly conditionalFormattingRules: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly expression: {
              readonly __typename: "JiraFormattingMultipleValueOperand";
              readonly fieldId: string;
              readonly multipleValueOperator: JiraFormattingMultipleValueOperator;
              readonly values: ReadonlyArray<string>;
            } | {
              readonly __typename: "JiraFormattingNoValueOperand";
              readonly fieldId: string;
              readonly noValueOperator: JiraFormattingNoValueOperator;
            } | {
              readonly __typename: "JiraFormattingSingleValueOperand";
              readonly fieldId: string;
              readonly singleValueOperator: JiraFormattingSingleValueOperator;
              readonly value: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            };
            readonly formattingArea: JiraFormattingArea;
            readonly formattingColor: {
              readonly colorKey: string | null | undefined;
            };
            readonly id: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"formatRules_businessConditionalFormattingSidebar_FormatRulesFragment">;
    } | null | undefined;
  } | null | undefined;
};
export type formatRulesQuery = {
  response: formatRulesQuery$data;
  variables: formatRulesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "colorKey"
},
v7 = {
  "kind": "ScalarField",
  "name": "formattingArea"
},
v8 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v9 = {
  "kind": "LinkedField",
  "name": "expression",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v8/*: any*/),
        {
          "alias": "singleValueOperator",
          "kind": "ScalarField",
          "name": "operator"
        },
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ],
      "type": "JiraFormattingSingleValueOperand"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v8/*: any*/),
        {
          "alias": "multipleValueOperator",
          "kind": "ScalarField",
          "name": "operator"
        },
        {
          "kind": "ScalarField",
          "name": "values"
        }
      ],
      "type": "JiraFormattingMultipleValueOperand"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v8/*: any*/),
        {
          "alias": "noValueOperator",
          "kind": "ScalarField",
          "name": "operator"
        }
      ],
      "type": "JiraFormattingNoValueOperand"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "formatRulesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "formatRules_businessConditionalFormattingSidebar_FormatRulesFragment"
              },
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFormattingRuleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFormattingRule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "formattingColor",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/)
                            ]
                          },
                          (v7/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "formatRulesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFormattingRuleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFormattingRule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "formattingColor",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v5/*: any*/)
                            ]
                          },
                          (v7/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "27842af21d3c4a1c89e9cf81f5d797dbb89b3da4ac6cc54f90271e8a38b37e39",
    "metadata": {},
    "name": "formatRulesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b2def96ee17b5bfd7a5b577bd4301147";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
